export default __webpack_public_path__ + "saige_logo.c4c7c514.svg";